<div>
  <div class="static_steps">
    <div class="side_part" cdkDropList #selectedProductsList="cdkDropList" [cdkDropListConnectedTo]="[productsList]"
      [cdkDropListDisabled]="!canSubmit"
      [cdkDropListData]="filteredSelectedProducts" (cdkDropListDropped)="drop($event)">
      <div class="step">
        <div class="step_title inline_title">
          <div>
            <span>{{"Catalogs.products_included"|translate}}  ({{filteredSelectedProducts.length}})</span>
            <span class="descr_title">{{"Catalogs.drag_and_drop_catalogs_in_this_bloc"|translate}}</span>
          </div>
          <div>
            <ng-container *ngIf="checkSelectedProducts.length > 0">
              <button class="add_all_btn remove_all_btn" *appHasPermission="submitPermission()" (click)="addSelectedProducts('selectedProductsList')">
                <img src="../../../../../assets/icones/remove_circle_red.svg" alt="" />
                <span>{{ "common.remove" | translate | titlecase }}</span>
              </button>
            </ng-container>
          </div>
          <div class="field">
            <input
              class="input"
              type="text"
              placeholder="{{ 'inventory.Search_product_SKU' | translate }}"
              [formControl]="selectedSearch"
            />
            <img src="assets/icones/search.svg" class="indicate_input" alt="">
          </div>
          <div class="filter_btns">
            <button class="filter" (click)="setFilter('selectedProductsList')">
              <img src="assets/icones/search-filter.svg" alt="" />
              <span>{{ "common.filter" | translate | titlecase }}</span>
            </button>
            <button
              class="clear"
              (click)="clearFilter('selectedProductsList')"
              *ngIf="isSelectedFiltered"
            >
              <small>{{ "common.clear" | translate | titlecase }}</small>
              <img src="assets/icones/clear-filter.svg" alt="" />
            </button>
          </div>
        </div>
        <div class="inside_content listing_table_container">
          <table class="listing_table">
            <thead class="header_stiky">
              <tr class="head_table">
                <th class="first_th">
                  <mat-checkbox #checkBox class="example-margin" [checked]="isAllChecked('selectedProductsList')" (change)="checkAllProducts('selectedProductsList')" [disabled]="isAllCheckedDisabled('selectedProductsList')"></mat-checkbox>
                  <span class="ml-10">Img</span>
                </th>
                <th>{{"common.name"|translate}}/ {{"inventory.sku"|translate}}</th>
                <th>{{"Catalogs.variant"|translate}}</th>
                <th>{{"brands.brands"|translate}}</th>
                <th>{{"inventory.categories"|translate}}</th>
                <th>
                  <img src="../../../../../assets/icones/remove_circle_dark.svg" alt="">
                </th>
              </tr>
            </thead>
            <tbody class="scrollable-body">
              <ng-container *ngFor="let product of filteredSelectedProducts; let i = index; trackBy: trackByFn">
                <tr class="body_table hover_tr" cdkDrag [cdkDragDisabled]="!canSubmit" [cdkDragData]="{selected: true, product}">
                  <td class="first_td">
                    <mat-checkbox class="example-margin" [checked]="isProductChecked(product.id!, 'selectedProductsList')" [disabled]="!canSubmit" (change)="checkProduct(product, $event, 'selectedProductsList')"></mat-checkbox>
                    <div class="img_product ml-10">
                        <img [src]="product.image ? baseUrl+product?.image + '?thumbnail=1' : placeholder" alt="">
                    </div>
                  </td>
                  <td class="td_block description_cell">
                    <span class="bold_span descr_elemnt">{{ product.name }}</span>
                    <span class="light_span descr_elemnt">{{product.sku}}</span>
                  </td>
                  <td class="td_actions">
                    <span class="bold_span">
                      {{product.variants ? product.variants.length : 0}}
                    </span>
                    <img *ngIf="product.attributes && product.attributes.length > 0" (click)="toggleVariants(product.id!)" [class]="expandedIndex === product.id ? 'arrow_down arrow_up' : 'arrow_down'" src="assets/icones/arrow_down.svg" alt="">
                    <span *ngIf="product.attributes && product.attributes.length > 0" (click)="toggleVariants(product.id!)" class="open_variants">{{expandedIndex === product.id ? ('inventory.HIDE' | translate) : ('inventory.SHOW' | translate) }}</span>
                  </td>
                  <td>{{product.brand?.name ?? '__'}}</td>
                  <td>
                    <div *ngIf="product.categories && product.categories.length > 0 else noCategories">
                      <span *ngFor="let category of product.categories" class="item_tag">
                        {{category.name}}
                      </span>
                    </div>
                    <ng-template #noCategories>
                      __
                    </ng-template>
                  </td>
                  <td>
                    <button *appHasPermission="submitPermission()" (click)="removeProduct(product)">
                      <img src="../../../../../assets/icones/remove_circle.svg" alt="">
                    </button>
                  </td>
                </tr>
                <tr *ngIf="expandedIndex === product.id">
                  <td colspan="6" class="td_variants">
                    <div class="variants_scroll">
                      <table class="variant_table">
                        <tr *ngFor="let variant of product.variants" class="body_table" cdkDrag [cdkDragDisabled]="!canSubmit" [cdkDragData]="{selected: true, variant_id: variant.id, product}">
                          <td class="first_td_variants">
                            <img *ngIf="variant.image" class="listing_image" [src]="baseUrl + variant.image + '?thumbnail=1'" alt="">
                            <img *ngIf="!variant.image" class="listing_image no-image" src="assets/icones/default-image-product.svg" alt="">
                          </td>
                          <td class="td_block description_cell">
                            <span class="bold_span descr_elemnt">
                              {{ variant.values.join(' / ') }}
                            </span>
                            <span class="descr_elemnt">
                              {{ variant.sku }}
                            </span>
                          </td>
                          <td></td>
                          <td>{{ product.brand?.name ?? '__' }}</td>
                          <td>
                            <div *ngIf="product.categories && product.categories.length > 0 else noCategories">
                              <span *ngFor="let category of product.categories" class="item_tag">
                                {{category.name}}
                              </span>
                            </div>
                            <ng-template #noCategories>
                              __
                            </ng-template>
                          </td>
                          <td>
                            <button *appHasPermission="submitPermission()" (click)="removeVariantsProduct(product, variant.id)">
                              <img src="../../../../../assets/icones/remove_circle.svg" alt="">
                            </button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="side_part" cdkDropList #productsList="cdkDropList" [cdkDropListConnectedTo]="[selectedProductsList]"
      [cdkDropListDisabled]="!canSubmit"
      [cdkDropListData]="products" (cdkDropListDropped)="drop($event)">
      <div class="step">
        <div class="step_title inline_title">
          <div>
            <span>{{"Catalogs.al_product"|translate}} ({{products.length}})</span>
            <span class="descr_title">{{"Catalogs.drag_and_drop_catalogs"|translate}}</span>
          </div>
          <div>
            <ng-container *ngIf="checkedProducts.length > 0">
              <button class="add_all_btn" *appHasPermission="submitPermission()" (click)="addSelectedProducts('allProductsList')">
                <img src="../../../../../assets/icones/add_circle_blanch.svg" alt="" />
                <span>{{ "common.add" | translate | titlecase }}</span>
              </button>
            </ng-container>
          </div>
          <div class="field">
            <input class="input" type="text" [placeholder]="'Catalogs.Search_product_SKU' | translate"  [formControl]="search" [readOnly]="(isAppLoading$ | async) === true"/>
            <img src="assets/icones/search.svg" class="indicate_input" alt="">
          </div>
          <div class="filter_btns">
            <button class="filter" (click)="setFilter('allProductsList')">
              <img src="assets/icones/search-filter.svg" alt="" />
              <span>{{ "common.filter" | translate | titlecase }}</span>
            </button>
            <button
              class="clear"
              (click)="clearFilter('allProductsList')"
              *ngIf="isProductsFiltered"
            >
              <small>{{ "common.clear" | translate | titlecase }}</small>
              <img src="assets/icones/clear-filter.svg" alt="" />
            </button>
          </div>
        </div>
        <div class="inside_content linsting_table_container">
          <table class="listing_table listing_table_products">
            <thead class="header_stiky">
              <tr class="head_table">
                <th class="first_th">
                  <mat-checkbox #checkBox class="example-margin" [checked]="isAllChecked('allProductsList')" (change)="checkAllProducts('allProductsList')" [disabled]="isAllCheckedDisabled('allProductsList')"></mat-checkbox>
                  <span class="ml-10">Img</span>
                </th>
                <th>{{"common.name"|translate}}/{{"inventory.sku"|translate}}</th>
                <th>{{"Catalogs.variant"|translate}}</th>
                <th>{{"brands.brands"|translate}}</th>
                <th>{{"inventory.categories"|translate}}</th>
                <th>
                  <img src="../../../../../assets/icones/add_circle.svg" alt="">
                </th>
              </tr>
            </thead>
            <tbody class="scrollable-body">
              <ng-container *ngIf="products.length === 0 && (products$ | async)!.length > 0">
                <div class="no_prdcts">
                  {{"Catalogs.allProductsPageSelected"|translate}}
                </div>
              </ng-container>
              <ng-container *ngFor="let product of products; let i = index; trackBy: trackByFn">
                <tr class="body_table hover_tr" cdkDrag [cdkDragDisabled]="!canSubmit" [cdkDragData]="{selected: false, product}">
                  <td class="first_td">
                    <mat-checkbox class="example-margin" [checked]="isProductChecked(product.id!, 'allProductsList')" [disabled]="!canSubmit" (change)="checkProduct(product, $event, 'allProductsList')"></mat-checkbox>
                    <div class="img_product ml-10">
                        <img [src]="product.image ? baseUrl+product?.image + '?thumbnail=1 ': placeholder" alt="">
                    </div>
                  </td>
                  <td class="td_block description_cell">
                    <span class="bold_span descr_elemnt">{{ product.name }}</span>
                    <span class="light_span descr_elemnt">{{product.sku}}</span>
                  </td>
                  <td class="td_actions">
                    <span class="bold_span">
                      {{product.variants ? product.variants.length : 0}}
                    </span>
                    <img *ngIf="product.attributes && product.attributes.length > 0" (click)="toggleVariants(product.id!)" [class]="expandedIndex === product.id ? 'arrow_down arrow_up' : 'arrow_down'" src="assets/icones/arrow_down.svg" alt="">
                    <span *ngIf="product.attributes && product.attributes.length > 0" (click)="toggleVariants(product.id!)" class="open_variants">{{expandedIndex === product.id ? ('inventory.HIDE' | translate) : ('inventory.SHOW' | translate) }}</span>
                  </td>
                  <td>{{product.brand?.name ?? '__'}}</td>
                  <td>
                    <div *ngIf="product.categories && product.categories.length > 0 else noCategories">
                      <span *ngFor="let category of product.categories" class="item_tag">
                        {{category.name}}
                      </span>
                    </div>
                    <ng-template #noCategories>
                      __
                    </ng-template>
                  </td>
                  <td>
                    <button *appHasPermission="submitPermission()" (click)="addProduct(product)">
                      <img src="../../../../../assets/icones/add_circle.svg" alt="">
                    </button>
                  </td>
                </tr>
                <tr *ngIf="expandedIndex === product.id">
                  <td colspan="6" class="td_variants">
                    <div class="variants_scroll">
                      <table class="variant_table">
                        <tr *ngFor="let variant of product.variants" class="body_table" cdkDrag [cdkDragDisabled]="!canSubmit" [cdkDragData]="{selected: false, variant_id: variant.id, product}">
                          <td class="first_td_variants">
                            <img *ngIf="variant.image" class="listing_image" [src]="baseUrl + variant.image + '?thumbnail=1'" alt="">
                            <img *ngIf="!variant.image" class="listing_image" src="assets/icones/no-image.png" alt="">
                          </td>
                          <td class="td_block description_cell">
                            <span class="bold_span descr_elemnt">
                              {{ variant.values.join(' / ') }}
                            </span>
                            <span class="descr_elemnt">
                              {{ variant.sku }}
                            </span>
                          </td>
                          <td></td>
                          <td>{{ product.brand?.name ?? '__' }}</td>
                          <td>
                            <div *ngIf="product.categories && product.categories.length > 0 else noCategories">
                              <span *ngFor="let category of product.categories" class="item_tag">
                                {{category.name}}
                              </span>
                            </div>
                            <ng-template #noCategories>
                              __
                            </ng-template>
                          </td>
                          <td>
                            <button *appHasPermission="submitPermission()" (click)="addVariantsProduct(product, variant.id)">
                              <img src="../../../../../assets/icones/add_circle.svg" alt="">
                            </button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
              <div *ngIf="products.length && products.length < allProducts.length" class="no_prdcts">
                {{"Catalogs.someProductsAreSelected"|translate}}
              </div>
            </tbody>
          </table>
          <div class="footer_sticky">
            <app-pagination [pagination]="pagination$ | async" (toPageEvent)="toPage($event)"></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">
      <span>{{submitType === 'stepper' ? ('common.BACK' | translate) : ('common.CANCEL' | translate)}}</span>
      <img src="../../../../../assets/icones/arrow_back.svg" alt="">
    </button>
    <button class="save_btn_pop_up blue_btn" *appHasPermission="submitPermission()" (click)="save()">
      <span>{{submitType === 'stepper' ? ('common.NEXT' | translate) : ('Catalogs.SAVE_CATALOG' | translate)}}</span>
      <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
    </button>
  </div>
</div>
